import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-white-close.svg'
import _imports_1 from '@/core/assets/icons/icon-lock.svg'


const _withScopeId = n => (_pushScopeId("data-v-26750130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "main" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("I ")
const _hoisted_4 = ["disabled", "placeholder", "id"]
const _hoisted_5 = {
  key: 1,
  class: "disabled-icon",
  src: _imports_1,
  alt: "disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_multiselect_drop_down_options = _resolveComponent("multiselect-drop-down-options")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-field", {opened: _ctx.opened && !!_ctx.search, warning: _ctx.hasError}]),
      style: _normalizeStyle({backgroundColor: _ctx.fill}),
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$refs[_ctx.id].focus()))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (selected, index) => {
        return (_openBlock(), _createElementBlock("section", {
          key: index,
          class: _normalizeClass({invalid: selected.invalid, disabled: _ctx.disabled}),
          style: _normalizeStyle({backgroundColor: _ctx.computedTagColor(selected)})
        }, [
          _createTextVNode(_toDisplayString(selected.title ? selected.title : selected.tag) + " ", 1),
          _createElementVNode("img", {
            onClick: _withModifiers(($event: any) => (_ctx.remove(selected)), ["stop"]),
            style: _normalizeStyle({backgroundColor: _ctx.computedTagColor(selected), color: _ctx.computedTagColor(_ctx.Selected)}),
            src: _imports_0,
            alt: "close"
          }, null, 12, _hoisted_2),
          _hoisted_3
        ], 6))
      }), 128)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        onKeydown: [
          _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$refs.options && _ctx.$refs.options.select()), ["enter"])),
          _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.options && _ctx.$refs.options.changeFocus("up")), ["prevent"]), ["up"])),
          _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.options && _ctx.$refs.options.changeFocus("down")), ["prevent"]), ["down"])),
          _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emptySearch && _ctx.emptySearch(...args)), ["esc"]))
        ],
        onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args))),
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args))),
        disabled: _ctx.disabled,
        style: _normalizeStyle({backgroundColor: _ctx.fill}),
        ref: _ctx.id,
        placeholder: !_ctx.disabled && _ctx.placeholder,
        id: _ctx.id,
        autocomplete: "off",
        type: "text"
      }, null, 44, _hoisted_4), [
        [_vModelText, _ctx.search]
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_loading_spinner, {
            key: 0,
            class: "loader"
          }))
        : _createCommentVNode("", true),
      (_ctx.disabled)
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.showDropDown)
        ? (_openBlock(), _createBlock(_component_multiselect_drop_down_options, {
            key: 2,
            class: "options",
            ref: "options",
            "default-tag-color": _ctx.defaultTagColor,
            loading: _ctx.loading,
            options: _ctx.options,
            "title-highight": _ctx.search,
            onSelect: _ctx.select,
            onRemove: _ctx.remove
          }, _createSlots({ _: 2 }, [
            (_ctx.showNoResultsMessage)
              ? {
                  name: "no-results-message",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.noResultsMessage), 1)
                  ])
                }
              : undefined
          ]), 1032, ["default-tag-color", "loading", "options", "title-highight", "onSelect", "onRemove"]))
        : _createCommentVNode("", true)
    ], 6)
  ], 512))
}